import { Component } from "@angular/core";
import { DepartmentService } from "../department/department.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";

@Component({
	selector: "departmentComponent",
	templateUrl: "/app/department/department.template.html",
	providers: [DepartmentService]
})
export class DepartmentComponent {

	departments: Array<IDepartmentModel>;
	department = {} as IDepartmentModel;
	editMode: boolean;

	constructor(private departmentService: DepartmentService, private toast: ToastsManager) { }

	ngOnInit() {
		this.getDepartments();
	}

    changeActiveStatus(department: IDepartmentModel): void {
        department.isActive = !department.isActive;
        this.department = department;
        this.saveDepartment(department);
    }

	getManagers(): void {
		this.departmentService.getDepartments().subscribe((result: Array<IDepartmentModel>) => {
			if(result)
				this.departments = result;
		});
	}

	getDepartments(): void {
		this.departmentService.getDepartments().subscribe((result: Array<IDepartmentModel>) => {
			if(result)
				this.departments = result;
		});
    }

	editDepartment(department: IDepartmentModel): void {
		this.department = department;
        this.editMode = true;
        this.departmentService.getPendingDepartmentReqs(this.department).subscribe((result: number) => {
            this.department.pendingReqs = result;
        });
	}

	saveDepartment(department: IDepartmentModel): void {
		if(department.id) {
			this.updateDepartment();
		} else {
			this.addDepartment();
		}
	}

	updateDepartment(): void {
		this.departmentService.saveDepartment(this.department).subscribe((result: any) => {
			if(result) {
				this.toast.success("", `${this.department.name} successfully saved!`, { toastLife: 10000 });
				this.editMode = false;
				this.cancelEditDepartment();
				this.getDepartments();
			}
		});
	}

	addDepartment(): void {
		this.departmentService.addDepartment(this.department).subscribe((result: any) => {
			if(result) {
				this.toast.success("", `${this.department.name} successfully added!`, { toastLife: 10000 });
				this.editMode = false;
				this.cancelEditDepartment();
				this.getDepartments();
			}
		});
	}

	cancelEditDepartment(): void {
		this.department = {} as IDepartmentModel;
		this.editMode = false;
    }
}